// src/app/modules/Visitors/pages/visitors-table/column-formatters/LastVisitFormatter.jsx
import React from "react";
import Moment from 'moment';
import { Calendar, Clock } from 'lucide-react';

export function LastVisitFormatter(cellContent, row) {
  const { visit_statistics } = row;

  if (!visit_statistics || !visit_statistics.last_visit) {
    return <span className="sety-tbl-sub">Never</span>;
  }

  const lastVisit = visit_statistics.last_visit;
  const isRecent = Moment(lastVisit).isAfter(Moment().subtract(7, 'days'));

  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5, display: 'flex', alignItems: 'center', gap: 5 }}>
        <Calendar size={13} />{Moment(lastVisit).format("MMM DD, YYYY")}
      </div>
      <div className="sety-tbl-sub" style={{ display: 'flex', alignItems: 'center', gap: 5, color: isRecent ? 'var(--green)' : undefined }}>
        <Clock size={12} />{Moment(lastVisit).fromNow()}
      </div>
    </div>
  );
}
